/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import appleTouchIcon from "../images/favicons/apple-touch-icon.png?"
import iconLarge from "../images/favicons/favicon-32x32.png?"
import iconSmall from "../images/favicons/favicon-16x16.png?"
import safariIcon from "../images/favicons/safari-pinned-tab.svg"

function SEO({ description, lang, meta, title, siteUrl, featuredImage }) {
	const { site, featuredImage: image } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						siteUrl
						description
						author
					}
				}
				featuredImage: file(
					absolutePath: { glob: "**/src/images/social-sharing.jpg" }
				) {
					childImageSharp {
						gatsbyImageData(layout: FIXED, width: 1200)
					}
				}
			}
		`
	)

	const metaDescription = description || site.siteMetadata.description
	const ogImage = featuredImage ?? image?.childImageSharp?.gatsbyImageData

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			siteUrl={siteUrl}
			titleTemplate={`%s`}
			meta={[
				{
					property: `og:image`,
					content: ogImage.images.fallback.src,
				},
				{
					property: `og:image:width`,
					content: `${ogImage.width}`,
				},
				{
					property: `og:image:height`,
					content: `${ogImage.height}`,
				},
				{
					name: `description`,
					content: metaDescription,
				},
				{
					name: "og:type",
					content: "website",
				},
				{
					property: `og:title`,
					content: title,
				},
				{
					property: `og:url`,
					content: siteUrl,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata.author,
				},
				{
					name: `twitter:title`,
					content: title,
				},
				{
					name: `twitter:description`,
					content: metaDescription,
				},
				{
					name: `msapplication-TileColor`,
					meta: `#ffffff`,
				},
				{
					name: `theme-color`,
					meta: `#ffffff`,
				},
			].concat(meta)}
			link={[
				{
					rel: `apple-touch-icon`,
					sizes: `180x180`,
					href: appleTouchIcon,
				},
				{
					rel: `icon`,
					sizes: `32x32`,
					type: `image/png`,
					href: iconLarge,
				},
				{
					rel: `icon`,
					sizes: `16x16`,
					type: `image/png`,
					href: iconSmall,
				},
				{
					rel: `mask-icon`,
					sizes: `16x16`,
					color: `#4d4d4d`,
					href: safariIcon,
				},
			]}
		/>
	)
}

SEO.defaultProps = {
	lang: `en`,
	meta: [],
	description: ``,
}

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired,
}

export default SEO
